import {useMemo} from 'react'
import {useIntl} from 'react-intl'
import {useAuth} from '../../../../app/modules/auth'
import {buildModuleNavigation, ModuleNavigationItem} from '../../../../app/platform/navigation'
import {useModule} from '../../../../app/platform/modules'
import {AsideMenuItem} from './AsideMenuItem'
import {ModularAsideMenuItemWithSub} from './ModularAsideMenuItemWithSub'

const ModularAsideMenuMain = () => {
  const intl = useIntl()
  const {auth, currentUser} = useAuth()
  const {defaultRoute, moduleCode} = useModule()
  const activeRoleName = auth?.role || currentUser?.roleName

  const items = useMemo(
    () =>
      moduleCode
        ? buildModuleNavigation({
            defaultRoute,
            menus: currentUser?.menus,
            moduleCode,
            roleName: activeRoleName,
          })
        : [],
    [activeRoleName, currentUser?.menus, defaultRoute, moduleCode]
  )

  const titleFor = (item: ModuleNavigationItem) =>
    item.titleKey ? intl.formatMessage({id: item.titleKey, defaultMessage: item.title}) : item.title

  return (
    <nav aria-label='Modül menüsü' className='nosi-module-navigation'>
      <div className='nosi-navigation-eyebrow'>Çalışma alanı</div>
      {items.map((item) => {
        if (!item.children || item.children.length === 0) {
          return item.to ? (
            <AsideMenuItem key={item.id} to={item.to} icon={item.icon} title={titleFor(item)} />
          ) : null
        }

        const firstChildRoute = item.children.find((child) => child.to)?.to || defaultRoute
        return (
          <ModularAsideMenuItemWithSub
            key={item.id}
            to={firstChildRoute}
            activeRoutes={item.children.flatMap((child) => (child.to ? [child.to] : []))}
            icon={item.icon}
            title={titleFor(item)}
          >
            {item.children.map((child) =>
              child.to ? (
                <AsideMenuItem
                  key={child.id}
                  to={child.to}
                  icon={child.icon}
                  title={titleFor(child)}
                />
              ) : null
            )}
          </ModularAsideMenuItemWithSub>
        )
      })}
    </nav>
  )
}

export {ModularAsideMenuMain}
